export const roadmed = [
    {
        id: 2,
        thumbnail:"https://i.ibb.co/vcMnX0n/B2-FIRST-17.png",
        title: "Flash Cards Anki",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo:"📒 Study Guide",url: "https://drive.google.com/file/d/1pKc3ccQW3ToLCZo3Hpl-t7AztxsMokMD/view?usp=sharing"},

            { titulo:"📑English - Listening and speaking deck B2",url: "https://drive.google.com/file/d/1WWS3zyzQlu_5Zkv0y9HqRJMT9CeQnkpl/view?usp=sharing"},
            { titulo:"📑Cambridge B2 APLICATIVO COMPLETO",url: "https://drive.google.com/file/d/1CU9wjKF6k91uq1vgXAiSPx9LQmIP9Gos/view?usp=sharing"},
            { titulo:"📑FCE_english_words_and_collocations",url: "https://drive.google.com/file/d/1v46CdxreA1fd9G6L9bzttZrP2zEu5zs7/view?usp=sharing"},
            
        ],
    },
    {
        id: 21,
        thumbnail: "https://i.ibb.co/yQ8fQ7L/B2-FIRST-12.png",

        title: "Pres. Simple vs Progressive",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/19FdH7nnsqL0Ez9siyiFv3PCEvt4EknFv/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1HRBxbp2b_5kcObTcgjMDmRKXH-xW0O4M/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1aAeXIW3wmnJwJjUTcCE6m7PV9aElcgeB/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1ugupTJWoGVpoH7q_UxAivmklT21IBsKv/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1HlMPxx9G-eXDvAkpnoYcD_qhH8DRcUt_/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1fQ23Xn4bXCSZJSaHGiWf5utUXeHAK0ma/view?usp=sharing", },
            { titulo: "✍ Present Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1Gjn3DIa6xRDKcbKFvUopOvzMTA7vnW02/view?usp=sharing", },


            


        ],
    },
    {
        id: 22,
        thumbnail: "https://i.ibb.co/yQ8fQ7L/B2-FIRST-12.png",

        title: "Past Simple vs Progressive",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/18h8QAkzm5UIzr-TF3DywBw_F-KtkjUYY/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1LCS98Vmh3gzPntxzCx5kX_EdackIK0v_/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1gxGscWmK3hDwJTXbNQpUEKlWSh_J9VLG/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1_3IiO9AC-y6Ks5RZujHdQyaWKKeMO9pu/view?usp=sharing", },
            { titulo: "✍ Past Tense Simple and Progressive ",url: "https://drive.google.com/file/d/1Cc3RqGtZefUPxDSohH0Xssr4OSO5uftZ/view?usp=sharing", },
        ],
    },
    {
        id: 24,
        thumbnail: "https://i.ibb.co/yQ8fQ7L/B2-FIRST-12.png",

        title: "Past vs Present Perfect",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Past Simple and Present Perfect (Simple and Progressive) ",url: "https://drive.google.com/file/d/10efo7YOPNaICX_E6_DQJsYZ5ctxm2xYQ/view?usp=sharing", },    
            { titulo: "✍ Past and Present Perfect Simple ",url: "https://drive.google.com/file/d/1Ngj2Ivf2Y8ak8QxCHo8QfLyTAOft-Qx0/view?usp=sharing", },
            { titulo: "✍ Past and Present Perfect Simple ",url: "https://drive.google.com/file/d/1D6keuz7pTkAnNv7mr2WRWoNIIlR5xaAu/view?usp=sharing", },
            { titulo: "✍ Letter to Janet - Past and Present Perfect Tense ",url: "https://drive.google.com/file/d/1gVcDYVZYAmhQQeKJPjDVnX9a49qiLyR5/view?usp=sharing", },
           

            
        ],
    },
    {
        id: 20,
        thumbnail: "https://i.ibb.co/yQ8fQ7L/B2-FIRST-12.png",

        title: "Modal Verbs",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {  titulo:"📝Modal Verbs 01 ",url: "https://drive.google.com/file/d/1Zgn5KfbaEf7exIqRM68RQTYBMcoaTOoP/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 02 ",url: "https://drive.google.com/file/d/15KaDhw2YaEcm7wXwU9EDVmR7pGH-XmU0/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 03 ",url: "https://drive.google.com/file/d/1KZS2o5INbRPQompRGWlp1E37JdjTl91I/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 04 ",url: "https://drive.google.com/file/d/1IlbtmcVPxi2tVOnH5cpKvy7TgeyNgQkE/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 05 ",url: "https://drive.google.com/file/d/1TkRPNcrpra3uhWXzH4fMBWZu7J8NFBK_/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 06 ",url: "https://drive.google.com/file/d/1C5BNy8t3qK5Ke9cyVcWorPNVS07hcPH5/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 07 ",url: "https://drive.google.com/file/d/16enX5sTyWnLGlZxUMEBCNRfkPzWtVr2M/view?usp=sharing"},
            {  titulo:"📝Modal Verbs 08 ",url: "https://drive.google.com/file/d/1lU75k9ZEKJM7wRsUpLz8LaUV6MuV8BRJ/view?usp=sharing"},

            


        ],
    }
    ,
    {
        id: 6,
        thumbnail: "https://i.ibb.co/yQ8fQ7L/B2-FIRST-12.png",
        title: "Passive Voice",
        subtitle: "Passive Voice",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "✍ PA001 - Passive Voice - Sentence Building",url: "https://drive.google.com/file/d/1dnTe8P1YghBdXX-241IbAgBwY4Q906_R/view?usp=sharing", },
            { titulo: "✍ PA002 - Passive Voice - Change from active to passive",url: "https://drive.google.com/file/d/1X5b3MMuae1HeE6f2pG80DVQWKOtJ99WW/view?usp=sharing", },
            { titulo: "✍ PA003 - Passive Voice - Change from active to passive",url: "https://drive.google.com/file/d/1TM66uLQjlKIPkq3eli2yS3DVyoYY3lfO/view?usp=sharing", },
            { titulo: "✍ PA004 - Passive Voice - Change from active to passive",url: "https://drive.google.com/file/d/11pcdPewzO3xDQrajcgLqmIN1lycd8zhO/view?usp=sharing", },
            { titulo: "✍ PA005 - Passive Voice - Change from active to passive",url: "https://drive.google.com/file/d/1xwtUMjpat16Sz1Qc5ig4Dh2rB2Jldgr-/view?usp=sharing", },
            { titulo: "✍ PA006 - Passive Voice - Make sentences using the tenses in brackets ",url: "https://drive.google.com/file/d/12WGBkRNI1TTH3LYZiDrLCn0XjIWoeIbQ/view?usp=sharing", },

            { titulo: "✍ PA007 - Passive Voice - Fill in the correct verb form",url: "https://drive.google.com/file/d/1PxVvJ02voPDyx2w0WPLM2qSfvmImyxgC/view?usp=sharing", },
            { titulo: "✍ PA008 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/1dYVPK0nnnPqC2A1cpx1h5MHHBNl4-mSW/view?usp=sharing", },

           
            { titulo: "✍ PA009 - Active and Passive Voice ",url: "https://drive.google.com/file/d/1hMKF8FFuuZJCcr8g-Uaky3fEdyRsj4B2/view?usp=sharing", },
            { titulo: "✍ PA010 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/1kef-fwn5XS-mdpFtBsJNaiBv9O6tapqn/view?usp=sharing", },
            { titulo: "✍ PA011 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/19frb1mIz5b0HzQ5x2mEuF_EUNGJcdal9/view?usp=sharing", },
            { titulo: "✍ PA012 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/1NWjGsI_acbNQzoHhc7wvIcLjDkZ1T3Ps/view?usp=sharing", },
         
            { titulo: "✍ PA013 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/1UDhwBHwvhaDM9Np6I8LXrGfNISgxidGZ/view?usp=sharing", },
            { titulo: "✍ PA014 - Passive Voice - Change from active to passive ",url: "https://drive.google.com/file/d/18kj21I16EGf-lcflLsecYN7oS8WLIXSH/view?usp=sharing", },
            { titulo: "✍ PA015 - Verb Tenses - Active or Passive Voice ",url: "https://drive.google.com/file/d/1J0928j_2Em_fLeSLqpxOImWcfcCCQv2L/view?usp=sharing", },
            { titulo: "✍ PA016 - A Local Sports Centre - Passive Voice ",url: "https://drive.google.com/file/d/1UZQPDIEmqOl0POB7gzbSnZo0zO6W9vzo/view?usp=sharing", },

            
        ],
    },
    
    
    
    
   
   
    {
        id: 13,
        thumbnail: "https://i.ibb.co/yQ8fQ7L/B2-FIRST-12.png",
        title: "General Vocabulary",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            {
                titulo: "✍GV001 - MAKE and DO",url: "https://drive.google.com/file/d/1UEYWUuHD3FKzJJFSG_OP9lBEAqhUx54k/view?usp=sharing",
            },
            { titulo: "✍ GV002 - MAKE and DO",url: "https://drive.google.com/file/d/1QPzo8Ck0ZevE8NE4rk7sCKJ-j9dZfQVZ/view?usp=sharing", },

            { titulo: "✍ GV003 - Opposites",url: "https://drive.google.com/file/d/1xoPKqzxYNSvH8rBQnKnAN_xVMAL7aio2/view?usp=sharing", },

           
            { titulo: "✍ GV004 - Opposites  ",url: "https://drive.google.com/file/d/14KyyQcO_HlG1CH3D8p12D55cnA2HqkmF/view?usp=sharing", },
            { titulo: "✍ GV005 - MAKE, DO, HAVE and GET  ",url: "https://drive.google.com/file/d/1ezVaxDVz1rfXiSzDYpFgzXYKGp9SBhUJ/view?usp=sharing", },
            { titulo: "✍ GV006 - Opposites  ",url: "https://drive.google.com/file/d/1R6pbUOru-AXvwM9yOb3JqTtTGzws6CAC/view?usp=sharing", },
            { titulo: "✍ GV007 - Nouns and Activities  ",url: "https://drive.google.com/file/d/1pgo4T6hPx0ybXAzLonEYE1yRLC1W3UPd/view?usp=sharing", },



          
           

            
        ],
    },
    {
        id: 0,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",
        title: "Recordings 2024",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
           
                { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=gGWtrDuoUi0" },
                { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?si=MHjaEN7bzBy3ZOhc&v=9bB9PgyB_bg&feature=youtu.be" },
                { "titulo": "[🖥️Class]  after", "url": "https://www.youtube.com/watch?v=5ilyP5xsyes&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?si=m4xdSF6v23GibP_H&v=CR6rnB5Yg0Y&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?si=tixxZisScjmyyLzI&v=eOtsLBuwvgw&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?si=dYFzG1VF98Tqkvyi&v=I5E5Q3yByPs&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 6", "url": "https://www.youtube.com/watch?si=-KYzJRc2XtTsfytL&v=OuqZlRsw7NE&feature=youtu.be" },
                { "titulo": "[🖥️Class]  day 7", "url": "https://www.youtube.com/watch?v=4hyP05BgB9M&list=PLaYNhMsVRuHhY6xcwxg931ib5xCbw2zWC&index=8&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 8", "url": "https://www.youtube.com/watch?v=XE7dOWDGpek&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 9", "url": "https://www.youtube.com/watch?v=w2i-Q7YHpvc" },
                { "titulo": "[🖥️Class]  day 10", "url": "https://youtu.be/1yYDsB_X9Ow" },
                { "titulo": "[🖥️Class]  day 11", "url": "https://www.youtube.com/watch?v=G7noYDWA80I&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 12", "url": "https://youtu.be/96wYFY3lUh4" },
                { "titulo": "[🖥️Class]  day 13", "url": "https://www.youtube.com/watch?v=tVZPNUMq2d0&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 14", "url": "https://www.youtube.com/watch?v=RAY0LxAjNOk&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 15", "url": "https://www.youtube.com/watch?v=Czy1TEgGXu4&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 16", "url": "https://www.youtube.com/watch?v=NZjOZDjhK3E" },
                { "titulo": "[🖥️Class]  day 17", "url": "https://www.youtube.com/watch?v=gpbEMX4KPk8" },
                { "titulo": "[🖥️Class]  day 18", "url": "https://www.youtube.com/watch?v=ez9eoYxzU-A&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 19", "url": "https://youtu.be/t1njSOFuS84" },
                { "titulo": "[🖥️Class]  day 20", "url": "https://youtu.be/oNkeUNBrjG0" },
                { "titulo": "[🖥️Class]  day 21", "url": "https://youtu.be/MdL2xj330bk" },
                { "titulo": "[🖥️Class]  day 22", "url": "https://youtu.be/LYrMkpMS5RY" },
                { "titulo": "[🖥️Class]  day 23", "url": "https://youtu.be/iYdTP-7wvzc" },
                { "titulo": "[🖥️Class]  day 24", "url": "https://youtu.be/esjEITmf8Ug" },
                { "titulo": "[🖥️Class]  day 25", "url": "https://youtu.be/OxXnEdw-LdU" }
            ],
            
    },
    {
        id: 1,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",


        title: "Recordings 2025",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
                { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=R2TVluocgUg&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=5&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=kLjAWxOYZDI&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=_FJtW3NHYxQ&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=2&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=uSoQGya3n_Y&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=3&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=ccyWNJz7FS4&list=PLaYNhMsVRuHit4WfPV4jdNX06vlIirQZp&index=4&ab_channel=MyEnglishBro" },
                
            ],
            
    },
    {
        id: 1,
        thumbnail:"https://i.ibb.co/PGdF1Pw/Dise-o-sin-t-tulo-7.png",

        title: "Recording IELTS 2024",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
                { "titulo": "[🖥️Class]  day 5", "url": "https://www.youtube.com/watch?v=nIZcH0sQSf0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=1&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 4", "url": "https://www.youtube.com/watch?v=C0RB86t1YIw&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=2&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 3", "url": "https://www.youtube.com/watch?v=TV10GT7j_es&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=3&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 2", "url": "https://www.youtube.com/watch?v=2ExYgxh9gjE&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=5&ab_channel=MyEnglishBro" },
                { "titulo": "[🖥️Class]  day 1", "url": "https://www.youtube.com/watch?v=UEEEwLpO7z0&list=PLaYNhMsVRuHjJu7pN_j8lKxb-r4Hjwc4_&index=4&ab_channel=MyEnglishBro" },
                
            ],
            
    },
    {
        id: 1,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: " English Expressions",
        subtitle: "B2/C1",
        color: "#D6083B", // Propiedad de color añadida

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Grabacion de clases Cambridge Preparation,no compartas las grabaciones ",
        enlaces: [
           
                { "titulo": "Turn the Tables", "url": "https://www.youtube.com/watch?v=3BP1kSUR1f0&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&ab_channel=MyEnglishBro" },
                { "titulo": "Watch your Mouth", "url": "https://www.youtube.com/watch?v=_eriRuRfvvM&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=2&ab_channel=MyEnglishBro" },
                { "titulo": "Spreading Rumors", "url": "https://www.youtube.com/watch?v=or0ZxUll78g&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=3&ab_channel=MyEnglishBro" },
                { "titulo": "Yo me lo busqué", "url": "https://www.youtube.com/watch?v=lcmn32R7u4k&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=4&ab_channel=MyEnglishBro" },
                { "titulo": "Agarrarle el ritmo", "url": "https://www.youtube.com/watch?v=hHITyx_4An8&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=5&ab_channel=MyEnglishBro" },
                { "titulo": "Empezar con el Pie Izquierdo", "url": "https://www.youtube.com/watch?v=oDkLrT8xRkg&list=PLaYNhMsVRuHh71-1ztahYIwp_PDrvbWJF&index=6&ab_channel=MyEnglishBro" },
              
            ],
            
    },
    
    {
        id: 1,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Information",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
            { titulo:"📚[pdf] B2 First Speaking Overview  ",url: "https://drive.google.com/file/d/1QJ_hjTeJIBEb01q5q7L-UeVwwK2sW0Wg/view?usp=sharing"},
           
        ],
    },
    {
        id: 19,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Prepositions",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {  titulo:"📝Prepositions 01 ",url: "https://drive.google.com/file/d/1ybpVAlxfM2Zvqe8xxBOPVCfFVCgk-W9U/view?usp=sharing"},
            {  titulo:"📝Prepositions 02 ",url: "https://drive.google.com/file/d/1PlFqX6zlyiNyjqOlaYQka6IeDomq0e0E/view?usp=sharing"},
            {  titulo:"📝Prepositions 03 ",url: "https://drive.google.com/file/d/1wDbMgx8z91WcmuY-6tF_aFLoRGhrXKd-/view?usp=sharing"},
            {  titulo:"📝Prepositions 04",url: "https://drive.google.com/file/d/1UHVi7z-9D8Es-kCBqmooDYLDlfB5vBct/view?usp=sharing"},
            {  titulo:"📝Prepositions 05 ",url: "https://drive.google.com/file/d/1ZqQgXsnezJZNDhCBA_3xO90IlsO3oN6o/view?usp=sharing"},

            


        ],
    }
    , 
    {
        id: 3,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Use of English - Part 1",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 1 ",url: "https://drive.google.com/file/d/1h54cY7q3mJV1UeyAmMKDHb9tLuTKgy65/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 2 ",url: "https://drive.google.com/file/d/1aeBR35udYiAWDQkReUq02MWQ45-mNlaY/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 3 ",url: "https://drive.google.com/file/d/1jxc8MXuj2aBSCE3n_K94IcyIz7DChfVX/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 4 ",url: "https://drive.google.com/file/d/13vp7gfLpY6nL8Fxqu-WI1yCcL2VbRUhp/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 5 ",url: "https://drive.google.com/file/d/11HwB5yX7D93zRPOVUF2RtDQPCplZDlCM/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 6 ",url: "https://drive.google.com/file/d/1g4U5r2kQXR-CB2j2acqwBz4ikNmWaWlf/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 7 ",url: "https://drive.google.com/file/d/1cqZwr_NyJ4pDkC9i5PiVpIOW-wIWpTwh/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 8 ",url: "https://drive.google.com/file/d/1Q1ls0rqyYuGNNGyVRRuoAZkuisAAqYC4/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 9 ",url: "https://drive.google.com/file/d/1ynY5s8E2_bNFnXdWlz0UAvIr2dg8GxeZ/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 10 ",url: "https://drive.google.com/file/d/1eELz_nshYOo48s2Dvjj-jU6E2mjh4zNx/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 11 ",url: "https://drive.google.com/file/d/1HbNg2K9EqAnu_LekOsClaAPyQe21syga/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 12 ",url: "https://docs.google.com/document/d/1hLDtbuz4h5Uc0WZz5ziOth3nXBdL4vrj/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 13 ",url: "https://drive.google.com/file/d/1SbgYMOfgIQHLGJbJqQndK5Hq-T7yC906/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 14",url: "https://drive.google.com/file/d/1P4EYZxf-LlzFdnoDUwfFQoQtDUHm2thY/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 15",url: "https://drive.google.com/file/d/1_ZouF_vlYUUZPVen-oZRkrYg10z684tn/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 16",url: "https://drive.google.com/file/d/1DKU9KwN7nqYHRpcllrq6uCiohtizg0o1/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 17",url: "https://drive.google.com/file/d/1pqkL1oyQX_pYglNVYzxd-F7VhvzS98E1/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 18",url: "https://drive.google.com/file/d/1_OEQdmovxPjXWo-ngaryTAKNDf13ronJ/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 19 ",url: "https://drive.google.com/file/d/1h-Kg1T7l9KgUecfEJC_r0pMZEIPMPpdE/view?usp=sharing"},
            { titulo:"📚[pdf] FCE Use of English Part 1, Test 20 ",url: "https://drive.google.com/file/d/1vXWiy1U15JiJOhDxa33qPTWf7kVupGfx/view?usp=sharing"},
        ],
    },
    {
        id: 25,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Word Formation (B2)",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ WF001 - Negative Forms ",url: "https://drive.google.com/file/d/1FoMiuTrYJHxJYyBsbBrqvs10Kb8cYf2T/view?usp=sharing", },    
            { titulo: "✍ WF002 - Prefixes and Negative Meanings ",url: "https://drive.google.com/file/d/1NI-L5UBxQ5gFeRac6oVhMXD_T-5YCjiv/view?usp=sharing", },    
            { titulo: "✍ WF003 - Crossword - Word Formation ",url: "https://drive.google.com/file/d/194QnF1Gc-wIRpiWAOtqWy-D8B78coaSL/view?usp=sharing", },    
            { titulo: "✍ WF004 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1j5T_mLOody8iDftkPJLcsPjNZ3pK9ot2/view?usp=sharing", },    
            { titulo: "✍ WF005 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1GAfwTA5CIrNcDW6hFA-Nbok78IlKdrh9/view?usp=sharing", },    
            { titulo: "✍ WF006 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1VsED-djskHE3PJwF2U8fXGPhENb07SxJ/view?usp=sharing", },    
            { titulo: "✍ WF007 - Word Formation Sentences ",url: "https://drive.google.com/file/d/11PrvYO0MoUzPqjgWwhPFARAdU9hOoKx8/view?usp=sharing", },    
            { titulo: "✍ WF008 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1susqk-7RPZOjTMidwHWzk2EDWCY_54CO/view?usp=sharing", },    
            { titulo: "✍ WF009 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1S9N--Mr5SS0nS7v3GLp4Xh2MKkhGh2d1/view?usp=sharing", },    
            { titulo: "✍ WF010 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1-W82gGyyTEkwiNn8_7n54jcS4vED76Fm/view?usp=sharing", },    

            { titulo: "✍ WF011 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1I4gNHDTaMU9lNwGsEv8Fyqct9NU2eXyR/view?usp=sharing", },    
            { titulo: "✍ WF012 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1aJM4ArL2IIOc48AM5tAhCUvf1MhWXfal/view?usp=sharing", },    
            { titulo: "✍ WF013 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1U0drN7vU3cQ67HifCfJcE0IpEt5jeUad/view?usp=sharing", },    
            { titulo: "✍ WF014 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1GpFgkjeAIjSzFftj3fLuo70W2K96CHEH/view?usp=sharing", },    
            { titulo: "✍ WF015 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1QampSegCjNaiMXPSvylWpawvPSwYoU6C/view?usp=sharing", },    
            { titulo: "✍ WF016 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1bfRaXcHxF_jtjmrdkIJYNi3-7kDRUAo6/view?usp=sharing", },    
            { titulo: "✍ WF017 - Word Formation Sentences ",url: "https://drive.google.com/file/d/18Omg11ZTsuP2_FAj1ygXHASgA70SVCq8/view?usp=sharing", },    
            { titulo: "✍ WF018 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1J2ZcjSpAXztp2Aw12RnYgh4w2FT0B3Xb/view?usp=sharing", },  
            
            
            { titulo: "✍ WF019 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/18krxCjRSmgc3wfWPtGK2qggwq0lUlfnW/view?usp=sharing", },    
            { titulo: "✍ WF020 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/18J49WKoMt8jXjiKAcxrFnaqTykF-0QHw/view?usp=sharing", },    
            { titulo: "✍ WF021 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/17L45VWvsHTY1ToaELcaEXaIpT8bgSKRB/view?usp=sharing", },    
            { titulo: "✍ WF022 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1pQvadnaDQBG7XFiBmcTBWcd63U9Ev5o0/view?usp=sharing", },    
            { titulo: "✍ WF023 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1C9hVqtk28R1nm-hx65SgSHl3_YDCZyVF/view?usp=sharing", },    
            { titulo: "✍ WF024 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1vLs14YohPvffTs6s3PuFznGWKsM0_1TV/view?usp=sharing", },    
            { titulo: "✍ WF025 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1w45SJf4eSJkURAPHI4Be2ygqhUfH8oGb/view?usp=sharing", },    
            { titulo: "✍ WF026 - Word Formation Sentences ",url: "https://drive.google.com/file/d/1ut_DldDoGR9ZqmMBjztnq2V_jtvyc6xW/view?usp=sharing", },    

            
        ],
    },
    {
        id: 4,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Key Word Transformation",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { titulo:"Presentación",url: "https://youtu.be/Hk1y2D9jbvQ"},

            { titulo:"Solución KWT 01 ",url: "https://youtu.be/muqLK--ykjg"},
            { titulo:"Test KWT 01 ",url: "https://drive.google.com/file/d/10cOoRCKkswKlwi2GOM4cvdOlWNBE-Hbx/view?usp=sharing"},
            { titulo:"Solución KWT 02 ",url: "https://youtu.be/7wrY5gW_Xco"},
            { titulo:"Test KWT 02 ",url: "https://drive.google.com/file/d/1VeU2a_peDOk2WMACF8anyG0GwLGZzOvM/view?usp=sharing"},
            { titulo:"Solución KWT 03 ",url: "https://youtu.be/D11X4WGnhuU"},
            { titulo:"Test KWT 03 ",url: "https://drive.google.com/file/d/1meGXse7csULGWCCAAOkANu1ckqn_bg5o/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 001 ",url: "https://drive.google.com/file/d/1fzxVyBLvMHRwzfHTGLgYapKOXasOXv0m/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 002 ",url: "https://drive.google.com/file/d/1AytA61HbBmJgFLcXNEwEBHJQjVelp1T3/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 003 ",url: "https://drive.google.com/file/d/1Kx3tL5lWNxOaeJwuu5bKqhaML8fi9nb6/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 004 ",url: "https://drive.google.com/file/d/1CkMzAwGVkwxbkDaLMAIaxo_cs3o4KADY/view?usp=sharing"},
            { titulo:"📚[pdf] Key Word Transformation 005 ",url: "https://drive.google.com/file/d/1qDQx3HJZL9Vkm6vOC9a-m7vUkqw4HMRa/view?usp=sharing"},

          
        ],
    },
    {
        id: 5,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Connectives and Linking Phrases ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
            { titulo:"📚[pdf] Connectives and Linking Phrases 001 ",url: "https://drive.google.com/file/d/1E-4DPNChktOiBETwI-npC9fPdRGotUqQ/view?usp=sharing"},
            { titulo:"📚[pdf] Connectives and Linking Phrases  002 ",url: "https://drive.google.com/file/d/1n3fWZPpV_DY9QCpUyvRqwO1wTMYZ67jA/view?usp=sharing"},
            { titulo:"📚[pdf] Connectives and Linking Phrases  003 ",url: "https://drive.google.com/file/d/1sxWll8fBOnh8JxQSUEYSF6ez4xqLhe3F/view?usp=sharing"},
            { titulo:"📚[pdf] Connectives and Linking Phrases  004 ",url: "https://drive.google.com/file/d/1nREywm6HXbce0qeVlH_kkcTV-DIAEtJI/view?usp=sharing"},

          
        ],
    },
    {
        id: 5,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Essential Grammar ",
        subtitle: "B2",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
          
            { titulo:"📚afraid to do vs afraid of doing ",url: "https://drive.google.com/file/d/19XX67MnZ-Mf-rmq9pPlYm9GMogYOHQa_/view?usp=sharing"},

            { titulo:"📚already/still/yet  ",url: "https://drive.google.com/file/d/126LmouA8outgNhw5x6wUcZI3F4tT1v4j/view?usp=sharing"},
            { titulo:"📚Amount ..Quantity ..Number  ",url: "https://drive.google.com/file/d/1CN4FalpOZBZ-SMMcatuxD_uasMzenrDA/view?usp=sharing"},
            { titulo:"📚apart from, aside from, except for  ",url: "https://drive.google.com/file/d/1EEftSd6UjyKcnVoP77VJFglfxUw_7gng/view?usp=sharing"},
            { titulo:"📚Aren't I vs Am I not ",url: "https://drive.google.com/file/d/1DKuTnhQurzBMHVo0P0GLL_EdI3y8LMvs/view?usp=sharing"},
            { titulo:"📚as far as, until, up to",url: "https://drive.google.com/file/d/16CJjTB0ZPDvQuzpOLMR22R0jK7QCe-c3/view?usp=sharing"},
            { titulo:"📚AS...AS... vs NOT SO...AS..",url: "https://drive.google.com/file/d/1VLCJlD5Tgn9XU3oUo05emwf23WkT5XQ8/view?usp=sharing"},
            { titulo:"📚ASK FOR - ASK AFTER - ASK ABOUT",url: "https://drive.google.com/file/d/1gkbuIZJ6sRy1jro8NPpOZLKO4p7naizC/view?usp=sharing"},
            { titulo:"📚At, In, By ( the end)..",url: "https://drive.google.com/file/d/1agtpiCvGtERX_ee7wHpNaax0hU1OmXyp/view?usp=sharing"},
            { titulo:"📚Future Plans- be going to vs present continuous",url: "https://drive.google.com/file/d/1Ov96Gz7ZEr3wDsnwDXF15q-6C8TrAPts/view?usp=sharing"},
            { titulo:"📚BE UP TO _ BE UP FOR",url: "https://drive.google.com/file/d/1xzD1SJQbZJ1aAxkM0jljNOAE2tPD_FYz/view?usp=sharing"},
            { titulo:"📚between you and me vs between you and I",url: "https://drive.google.com/file/d/1cpk7V_8qdxoX8VUpZYRT5zq_9GrCoWzc/view?usp=sharing"},
            { titulo:"📚25 Common Binomials",url: "https://drive.google.com/file/d/1LgAKdAj0ftr1PIN46d4aAdBLuiyEdaPl/view?usp=sharing"},
            { titulo:"📚BY, IN, ON + ING",url: "https://drive.google.com/file/d/1VmZIuWIV0IXYDd1RGtIo7krxPcBPGLOF/view?usp=sharing"},
            { titulo:"📚by the time (that), by now, by then.",url: "https://drive.google.com/file/d/1VQxnXCmbei5cxZucSW8FJKBOdgMQGRmO/view?usp=sharing"},
            { titulo:"📚cannot vs can not",url: "https://drive.google.com/file/d/1CXcCzrtdDif6iBEi75d_9CFxIE6847Q4/view?usp=sharing"},
            { titulo:"📚CAUSATIVE VERBS (have - get) ",url: "https://drive.google.com/file/d/1-PErCarKwe61HtSAbgx2wtJapHkBM9bp/view?usp=sharing"},
            { titulo:"📚Table CAUSATIVE VERBS (have - get) ",url: "https://drive.google.com/file/d/1NoE0tUIpAlHgGNHc1xBIi_YFIyoBax15/view?usp=sharing"},
            { titulo:"📚Chance of-Chance to... ",url: "https://drive.google.com/file/d/18otkt_PTLMwlZGqs4rBnXRMdhz48xUaS/view?usp=sharing"},
            { titulo:"📚CLEFT SENTENCES (TABLE) ",url: "https://drive.google.com/file/d/13-JhSbUYrCntdTi5t097wDYyeUmJH-g1/view?usp=sharing"},
            { titulo:"📚Consist in vs Consist of.. ",url: "https://drive.google.com/file/d/1F-XK5pIbsWwlOIDU-XfXpEVATQdlTggq/view?usp=sharing"},
            { titulo:"📚continually,  continuously ,  constantly",url: "https://drive.google.com/file/d/1kENm-lqtM22jiVAej6_Io_IoYFeRDprC/view?usp=sharing"},
            { titulo:"📚CORRELATIVE CONJUNCTIONS",url: "https://drive.google.com/file/d/16ud5EPb-q127g3tRlHKoV_Pk5HKpLoh8/view?usp=sharing"},
            { titulo:"📚count on - depend on - rely on",url: "https://drive.google.com/file/d/1DxZyMcb1NwXXbt_wIAbhPTiNFMuvAKG6/view?usp=sharing"},
            { titulo:"📚DECISIONS, PLANS, PREDICTIONS",url: "https://drive.google.com/file/d/1LirHWCiSSatbjAv8q1ItdX32fnY2Tk8c/view?usp=sharing"},
            { titulo:"📚DESPITE vs IN SPITE OF",url: "https://drive.google.com/file/d/1Mz8VnETibHBD0ID3hanTfrNS66xHU6_h/view?usp=sharing"},

        ],
    },
    {
        id: 12,
        thumbnail:
            "https://i.ibb.co/f4YQsS1/B2-FIRST-11.png",
        title: "Essential Grammar ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { "titulo": "[🖥️Class] Need + ing", "url": "https://www.youtube.com/watch?v=TwRQIGq2Uw0&ab_channel=MyEnglishBro" },

            { titulo:"📚[Slide] Phrasal Prepositional Verbs Three-Word Phrasal Verbs  ",url: "https://drive.google.com/file/d/1S9AN2o1ItWcwPcdv6NuGsltrOMTj5Dr5/view?usp=sharing"},
            { titulo:"📚[Slide] Popular English Proverbs  ",url: "https://drive.google.com/file/d/1A8KPhIU9Txfi6_BVKpQYcIN6QtKvdu4v/view?usp=sharing"},
            { titulo:"📚[Slide] Hyphenated Compound verbs in English  ",url: "https://drive.google.com/file/d/132D6JBpECMY_gbwPBVvOl4f2k3nWs6G5/view?usp=sharing"},
            { titulo:"📚[Slide] Adding extra information  ",url: "https://drive.google.com/file/d/1d4ekX50tF7DulMtfp1sKhhWrg59TqNWq/view?usp=sharing"},
            { titulo:"📚[Slide] Advanced Comparatives  ",url: "https://drive.google.com/file/d/1kFTnMfMalxHz65aOTpDBn2KbPTmv6BPp/view?usp=sharing"},
            { titulo:"📚[Slide] Advanced Comparatives 2  ",url: "https://drive.google.com/file/d/1k-Lc6dy-aPFwoUYuNHJ_YzAWDxjttSdE/view?usp=sharing"},
            { titulo:"📚[Slide] Advanced English Suffixes  ",url: "https://drive.google.com/file/d/19QT3eSGDIw0luGzgpbbL_xxn4fSGRWep/view?usp=sharing"},
            { titulo:"📚[Slide] Advanced Structures ",url: "https://drive.google.com/file/d/1GvW9GeD6tA7aIfpaKdPqR13vmpZxQSaN/view?usp=sharing"},
            { titulo:"📚[Slide] As it is / As it were ",url: "https://drive.google.com/file/d/168WIIEOirBRRtLgp6LG3z__dxm87KyTg/view?usp=sharing"},
            { titulo:"📚[Slide] As...As...(phrases) ",url: "https://drive.google.com/file/d/13xHkeweXxT7wrqVkDNvA2lX0PuSKn0S7/view?usp=sharing"},
            { titulo:"📚[Slide] Be up/ Be down phrases ",url: "https://drive.google.com/file/d/1qPG9T5MDNLd01IAi3woFqWyRn9MOc8h4/view?usp=sharing"},
            { titulo:"📚[Slide] Binomials ",url: "https://drive.google.com/file/d/1auzNr8YBvZyU9Fer43Xs0QZbGdYz7ARS/view?usp=sharing"},
            { titulo:"📚[Slide] Causative Verbs : Have and Get ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Cause for + Noun ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Chance to do / Chance of doing ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Cleft Sentences ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Come as a .. to someone",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Common  C1/C2 Reflexive Pronouns",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Common  Correlative Conjunctions",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Common  Words with silent letters in English ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Conditionals - Advanced Conditionals ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Conditionals - Conditionals Expressions ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Conditionals - If sentences -C1-C2 ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Conditionals - Mixed Conditionals ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Consist in - Consist of ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Count on/ Depend on / Rely on  ",url: "https://drive.google.com/file/d/1V1ru2-rRsqE8GlxGYcf5UzBbrLm9cVBZ/view?usp=sharing"},
            { titulo:"📚[Slide] Differentiate,Distinguish,Discriminate ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Indirect and Direct Speech ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Doing too much - phrases ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Doubt that / Doubt whether /if ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Emphatic Pronouns ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Ever to express emphasis ",url: "https://drive.google.com/file/d/1dyiH6U2JL6y85GWJ7R976gTw2DV5HZPV/view?usp=sharing"},
            { titulo:"📚[Slide] Exclamation with What and How",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Expressing lack of Surprise (Phrases)",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Extent - Phrases",url: "https://drive.google.com/file/d/1RNL8yvP8ciMWWd_vnp0hIsFfUpuANjEe/view?usp=sharing"},
            { titulo:"📚[Slide] For meaning because ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Future Continues ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Give rise to  / Give way to   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Having a lot to do   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Historical Present    ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Hope-Phrases    ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] I wish you didn't / I wish you wouldn't    ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] If I were / If I was   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] If meaning although   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Immediate Future Expressions   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Impersonal Passive/ Personal Passive  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Imposing or Transferring responsability  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Inasmuch as  vs insofar as   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] In the (short/medium /long) term / in the (short/long)run ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Including or omitting relative pronouns  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Indeed -How to use this word   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Inversion - Advanced Structures  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Inversion in English -Neither and Nor  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Inversion in English ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] It as an empty object   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] It comes a time when ....or There comes a time when .. ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] It's a good job /It's a good thing / It's just as well   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] It's about /high time + past subjunctive   ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Joining Negative Ideas ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Make it so that -Phrase ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Might ( criticism / suggestions)",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Much to someone's ../To someone's.. ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Muse, Amuse , Bemuse  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Not as ...as..., Not so ... as..",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Not so much .../Not...so much as .../Not so much ...as",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] ONLY meaning but or except",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Participle Clauses",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Phrases meaning in Addition ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Phrases with All ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Phrases with Along ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Phrases with Cases ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Phrases with Once ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Phrases with Yet ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Ponder  vs Pander  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Possessive Gerunds ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Present Habits ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Prevent,Stop, Avoid ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Propose ,Recommend,Suggest ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Put someone to something - Put something to someone",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Reduce Relative Clauses  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Reduplicatives ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Result in / Result From  ",url: "https://drive.google.com/file/d/1BTmXONrNQGIn9JuG8zngDx0Fck6v2MnW/view?usp=sharing"},
            { titulo:"📚[Slide] Saxon Genitive - Special Cases ",url: "https://drive.google.com/file/d/1hUR9QCWDUMgI2-6ZdNMUKC8DlzjHkYtc/view?usp=sharing"},
            { titulo:"📚[Slide] Singular They",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] So + adjectives +that/ So+ adjectives+as to ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] So much (Phrases)",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] -some(adjective suffix) ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Some to express positive/negative opinion ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Something/A bit/Someone...of a something ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Spoken English -Advanced Phrases ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] STILL meaning despite that ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Subjunctive mood in English",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Substitution with 'Do so'  ",url: "https://drive.google.com/file/d/1cDQYA8CIBaBKuYwBlERsFkKxtMLa2CbC/view?usp=sharing"},
            { titulo:"📚[Slide] Tag Questions -Imperatives  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Tag Questions - Questions Tags :There  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Tag Questions - Universal Tags Questions ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Tag Questions - Double Positives ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Tags - Statement/Reinforcement Tags ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] The fact that  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] There is no questions (phrases) ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] To + Gerund(Phrases) ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] To bits(phrases) ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] To-infinitive in non-finite relative clauses",url: "https://drive.google.com/file/d/12MXy8BXPHM2bOuUqbZkfld5vmp9ye03t/view?usp=sharing"},
            { titulo:"📚[Slide] To like some or something -Phrases ",url: "https://drive.google.com/file/d/1gOzxiEFLu_IyCAUqaQM3yPJKsFSRFOj9/view?usp=sharing"},
            { titulo:"📚[Slide] To use something to achieve something -Phrases ",url: "https://drive.google.com/file/d/1uACXzYYygl6bmK0mKXsYZ7kgysVD7H2o/view?usp=sharing"},
            { titulo:"📚[Slide] Trinomials ",url: "https://drive.google.com/file/d/1jmROcj7We2J1xV26AwJZfyrwUj0lmjf5/view?usp=sharing"},
            { titulo:"📚[Slide] Trust ,Distrust ,Entrust ",url: "https://drive.google.com/file/d/1gC2SLjM0tML-TVWLjl6a4V6wHYYkokbp/view?usp=sharing"},
            { titulo:"📚[Slide] Useful Homophones ",url: "https://drive.google.com/file/d/1MWO2XHuHp0bAzFceREIteP_cKXyuwe1j/view?usp=sharing"},
            { titulo:"📚[Slide] Very + Noun ",url: "https://drive.google.com/file/d/1oiyHIL4pSRBzTwnXmNtl6pPboSqoY76u/view?usp=sharing"},
            { titulo:"📚[Slide] Wait ,Await, Expect ",url: "https://drive.google.com/file/d/1C1llJJ8yFX0i5pxSnTMUWPIjmNvISnHB/view?usp=sharing"},
            { titulo:"📚[Slide] Wary vs Weary",url: "https://drive.google.com/file/d/1C8y5Va1PO0FC5UJHWf5HQ4hwBq27lb_y/view?usp=sharing"},
            { titulo:"📚[Slide] What little ,What few ",url: "https://drive.google.com/file/d/1T6khMo1jZdg8ZbNJk1OPBViUBizGTCLo/view?usp=sharing"},
            { titulo:"📚[Slide] When is 'THE' used with superlatives ? ",url: "https://drive.google.com/file/d/1ANoTemvWys1sMGooLBQZyrVaBiWwmk2c/view?usp=sharing"},
            { titulo:"📚[Slide] Will/Would Expressing Willingness and Unwillingness ",url: "https://drive.google.com/file/d/1OSlsIu3un1pwemLHChzkEApSyeaP77ZA/view?usp=sharing"},
            { titulo:"📚[Slide] -wise (suffix) ",url: "https://drive.google.com/file/d/1zzSan5isa6ok5M8b3TXW_Nm8eCcu9Eza/view?usp=sharing"},
            { titulo:"📚[Slide] WITH meaning because of ",url: "https://drive.google.com/file/d/1SGvkOoVIsU6ILExH_eyTHYYodpXDJlLO/view?usp=sharing"},
            { titulo:"📚[Slide] Would rather/Would Sooner ",url: "https://drive.google.com/file/d/1F-t7qwMfcb5PDKfFodN02qZFwCzIZFqu/view?usp=sharing"},

            { titulo:"📚[Slide] Summary Grammar : Resumen de Gramática Fundamental para Aprobar  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},

            {
                titulo: "🎯[Activity] Introduction to the Course",
                url: "https://wordwall.net/play/11758/458/200",
            },
            { titulo:"📚[book] Summary Grammar : Resumen de Gramática Fundamental para Aprobar  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[pdf] First Conditional Grammar  ",url: "https://drive.google.com/file/d/1TtQyZh4nbaFmMEGqPHxpHIx9LhNoWbMh/view?usp=sharing"},
            { titulo:"📚[ppt] Causative Grammar  ",url: "https://docs.google.com/presentation/d/1JqpdJ7rwpjCj7IRuHw8mkN2ZljQxkYbt/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true"},
            { titulo:"📚[pdf] Impersonal/Personal Passive   ",url: "https://drive.google.com/file/d/1ro-Akv2tledwTQjsG984zZsbYmrUhxY9/view?usp=sharing"},
            {
                titulo: "🎯[Activity] Impersonal/Personal Passive 01",
                url: "https://wordwall.net/play/11758/458/200",
            },
            {
                titulo: "🎯[Activity] Impersonal/Personal Passive 02",
                url: "https://wordwall.net/play/14060/593/9112",
            },
            {
                titulo: "🎯[Activity - Speaking] Impersonal/Personal Passive 03",
                url: "https://wordwall.net/play/55183/950/878",
            },
            {
                titulo: "🎯[Activity] Impersonal/Personal Passive 04",
                url: "https://wordwall.net/play/38436/833/237",
            },
            {
                titulo: "🎯[Activity]  Passive Voice",
                url: "https://wordwall.net/play/38436/833/237",
            },
            { titulo:"📚[pdf] Direct/Indirect Speech  ",url: "https://drive.google.com/file/d/1uVIQAKwwsRmvlzC9UNvKH3vrKmMak6F6/view?usp=sharing"},
            { titulo:"📚[ppt] Gradable/Non Gradable Adjectives Grammar  ",url: "https://docs.google.com/presentation/d/1rNNytCWmiO5_TVlt-3yANAjAfAiJQn8c4JzC80tZYrg/edit?usp=sharing"},

            { titulo:"📚[ppt] Inversion  ",url: "https://docs.google.com/presentation/d/13x3PsYRJVv5F6oeoVyim8Y7SBSx1udVd/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true"},
            { titulo:"📚[ppt] Inversion Full  ",url: "https://drive.google.com/file/d/1spoUQkw5ZlS6xnDsjni4-k-01SE0ERJW/view?usp=sharing"},
            { titulo:"📚[ppt] Used to/ be used to / get used to   ",url: "https://drive.google.com/file/d/10RJV_9F_2hLn04DslKk5aDae3AdVOa8s/view?usp=sharing"},
            { titulo:"📚[ppt] Whom/whose/Who  ",url: "https://drive.google.com/file/d/1SXlXv80QurkFMcgQ-0PJ0kb8WJOL_Cr9/view?usp=sharing"},
            { titulo:"📚[pdf] Wait/hope/Expect Grammar FunSheet  ",url: "https://drive.google.com/file/d/1d98aBmRU07TtUiQvHhlU2bAklTRQ2iLZ/view?usp=sharing"},

        ],
    },
    {
        id: 5,
        thumbnail:"https://i.ibb.co/DM385Vn/B2-FIRST-15.png",

        title: "Essential Grammar ",
        subtitle: "C2",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
          
            { titulo:"📚 Dangling Modifiers  ",url: "https://drive.google.com/file/d/1-MCDQdx5K_v6mEL7dgjh6TU4rTdfFVSN/view?usp=sharing"},

          
        ],
    },
    
    
    {
        id: 13,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Speaking Center",
        subtitle: "B2/C1",
        color: "#8F2BBC",


        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Aprende a hablar como un hablante nativo enfocándote en la pronunciación, entonación y expresiones idiomáticas para mejorar tu fluidez y naturalidad al hablar.",
        enlaces: [
            {
                titulo: "🖥️[Video] Episodem  Website",
                url: "https://www.youtube.com/watch?v=9dt6WOuoXos",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 01",
                url: "https://drive.google.com/file/d/1QhvhLsCjF6V1BaYqpSd3cV9lgNuOCw_h/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 02",
                url: "https://drive.google.com/file/d/1h-s_T2_bFtZngCACYPMKw4U1V4mB6Ove/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 03",
                url: "https://drive.google.com/file/d/1vm6K2C5j061v2IneytvApO-r9tCdd3KS/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 04",
                url: "https://drive.google.com/file/d/1dGhBsbgRejXuovsdRie-bae23WpeY4V6/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 05",
                url: "https://drive.google.com/file/d/1ItqYXZB6Dc19PdmaB67E-9EZyAyfrl9y/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] Speaking Trainer 01",
                url: "https://drive.google.com/file/d/1n-sf1L6DJZKdj0GSGV2zlPlaYI4WhJQ9/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] Speaking Trainer 02",
                url: "https://drive.google.com/file/d/1Jiwqspyx05GE1Br1tTir8j-xWm1_-VbG/view?usp=sharing",
            },
            
            {
                titulo: "🎯[Activity] speaking Part 1",
                url: "https://wordwall.net/play/519/287/727",
            },
            {
                titulo: "📒[pdf] Linking Words | B2 First (FCE)",
                url: "https://drive.google.com/file/d/1l7NLEB9G7uwaXkRONIKNJE7BjucKC_pC/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] 10 Preguntas de examen – Speaking Parte 1 (Entrevista) | B2 First (FCE)",
                url: "https://drive.google.com/file/d/1Oe2kqUUQnetTzjYCcia8mx2IrPEurE92/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Explanation",
                url: "https://drive.google.com/file/d/1lQkT1_qz3fPUBqcysqdvxvi6bNtOmXab/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 1 - Useful Phrases",
                url: "https://drive.google.com/file/d/1Fty0C6H85HUHEJBG0KzAAOGK5a6FVMgz/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 2 - Useful Phrases",
                url: "https://drive.google.com/file/d/1vHp3IrV3Wiz1a2m8_GdbdIl3ITc4sf2e/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 3 - Useful Phrases",
                url: "https://drive.google.com/file/d/19HB0czJM2-XZZBuKr3FXHNAn8jP941DF/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 4 - Useful Phrases",
                url: "https://drive.google.com/file/d/1ZmLmEIS1vnRPbZD9D20vFkEJPpoE9jbm/view?usp=sharing",
            },
            {
                titulo: "📒Mistakes at First ",
                url: "https://drive.google.com/file/d/1GqRFqwYpNz2b52QJIJ9-RIGKOxkEV5HS/view?usp=sharing",
            }
            
            
        ],
    },
   
    {
        id: 14,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Listening Center",
        subtitle: "B2/C1",

        dateAdded: "B2/C1",
        channel: "sdasd",
        description: "Mejora tus habilidades de comprensión auditiva con este curso que te ayudará a entender a hablantes nativos en diferentes situaciones y acentos, fortaleciendo tu confianza al escuchar y comprender el idioma.",
        enlaces: [
            { titulo: "Listening Test 01", url: "https://drive.google.com/file/d/1D5AdAH1i9YgRKAPjt1hTCTFbZNSzb7mZ/view?usp=sharing" },
            { titulo: "Listening Test 02", url: "https://drive.google.com/file/d/15L0kGEMCnG64fOmwEyHI26fvKXDsRxjj/view?usp=sharing" },
            { titulo: "Listening Test 03", url: "https://drive.google.com/file/d/1MDFFBQWUYZIfHR1Sq8uh7NwUFeEbLabk/view?usp=sharing" },
            { titulo: "Listening Test 04", url: "https://drive.google.com/file/d/1XtMuAyPYc_eOO1ZM5xuPnKZlw8fci5MF/view?usp=sharing" },
            { titulo: "Listening Test 05", url: "https://drive.google.com/file/d/1gbY6fJBvFXn-L3qs_wgK_hvYCIhbfcWJ/view?usp=sharing" },
            { titulo: "Listening Test 06", url: "https://drive.google.com/file/d/1nmFFhMgNcZSmkpYe1PqHQ2lMeIdgghEQ/view?usp=sharing" },
            { titulo: "Listening Test 07", url: "https://drive.google.com/file/d/1C7B6D6Z_e-k9ugmEojOGuVtvmSHe2ojS/view?usp=sharing" },

            { titulo: "🦻Listening Trainer 01", url: "https://drive.google.com/file/d/1MKkEnM6ABu8UmYtqmWdG6wEFbPnNHwIq/view?usp=sharing" },
            { titulo: "🦻Listening B2 TEST 01", url: "https://drive.google.com/file/d/1zLZ9sYxQ9BLNEtLF391_VhItr8mrmCBX/view?usp=sharing" },

            {
                titulo: "🖥️[Video] Listening  Trainer 01",
                url: "https://drive.google.com/file/d/16rLz8vX-25nVKvO2y7_HIJ2j2Ay_-XL_/view?usp=sharing",
            }
            
    
        ],
    },
    
    {
        id: 15,
        thumbnail:
            "https://i.ibb.co/0XR5yjD/990527648dc1fe389bb8568a632839e8-removebg-preview.png",
        title: "M4 - English Verb Patterns",
        subtitle: "Basic Level",

        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "We will learn to introduce ourselves, spell names and words, describe people, introduce family members, and provide personal information.",
        enlaces: [
            { titulo: "📒[slides] Transitive and Intransitive Verbs",url: "https://drive.google.com/file/d/1q9Ay8KRUU9tSwuHEvjIM8bKZ3PWCyjkZ/view?usp=sharing", },
            { titulo: "📒[slides] Gerunds and Infinitives Explanation",url: "https://drive.google.com/file/d/1rE08bQrEyF0TVO7FTYWGtLaiOGKuLjRO/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 1",url: "https://drive.google.com/file/d/1KJKLqjSwQeILyViRun9ADqge1ikKPmSD/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 2",url: "https://drive.google.com/file/d/19WY1c2LJZrAjj84niwx-u5dgh-dafQb6/view?usp=sharing", },
            { titulo: "✍  Gerunds and Infinitives Exercise 3",url: "https://drive.google.com/file/d/1xURjjQPkur3dYBtFRuZTmbnqlC-ZCb2b/view?usp=sharing", },
            { titulo: "💡  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1H6BxX1OPZ-5fU7peCACnw6vRV5-lnUPW/view?usp=sharing", },
            { titulo: "🔑  GI003 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1OYpGW81Wt7dvLTsTa7zddJRJIKKo7Mpn/view?usp=sharing", },
            { titulo: "💡  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1GOe8JtMyfLpayGkIgkUn1IkGRblKsoGf/view?usp=sharing", },
            { titulo: "🔑  GI004 - Gerund or Infinitive - Fill in the correct form ",url: "https://drive.google.com/file/d/1iAOBovzOkjJH9Z9rToPCj8losTuXz9ov/view?usp=sharing", },
            { titulo: "🧩  Desafio gerund vs infinitive",url: "https://wordwall.net/play/7240/772/7948", },
            { titulo: "🧩  Desafio gerund vs infinitive II",url: "https://wordwall.net/play/22920/270/462", },
            { titulo: "🧩  Desafio gerund vs infinitive III",url: "https://wordwall.net/play/76232/915/656", },
            { titulo: "🧩  Desafio gerund vs infinitive IV",url: "https://wordwall.net/play/71477/712/378", },
            { titulo: "🧩  Desafio gerund vs infinitive V",url: "https://wordwall.net/play/75464/667/869", },
            { titulo: "🧩  Desafio gerund vs infinitive VI ",url: "https://wordwall.net/play/59257/372/969", },
            { titulo: "🧩  Desafio gerund vs infinitive VII ",url: "https://wordwall.net/play/4838/285/4447", },

           
           



          
            {
                titulo: "📒[slides] UNIT 5:PRESENT PERFECT AND SIMPLE PAST",
                url: "https://docs.google.com/presentation/d/1bpMRMy7LVba68bhwB6w2KUEXmD7n-MAP/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },

            
        ],
    },
    {
        id: 18,
        thumbnail:
            "",
        title: "M4 - Phrasal Verbs",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            


            {titulo: "📒Phrasal verb with Get",url: "https://drive.google.com/file/d/1txaA2U2EMDVKnJ--_UM8YhzDZBaHasDP/view?usp=sharing",},
            {titulo: "📒Phrasal verb with Take",url: "https://drive.google.com/file/d/1ZkjaNFOku-6MgJSzH_QRRXHoYGm02uLQ/view?usp=sharing",},
            {titulo: "📒Phrasal verb Get vs Take",url: "https://drive.google.com/file/d/1XyP5ABzwxOESdOwnOucJ_2-3beKDqxwv/view?usp=sharing",},
            {titulo: "📒Phrasal verb with Up",url: "https://drive.google.com/file/d/1B7kiX_3JXK8jiRYNFkR4IxPqoHCz0J7K/view?usp=sharing",},
            {titulo: "📒Phrasal verb Dictation",url: "https://drive.google.com/file/d/1Q78yaqJPpqUThoLZ4y5tqPFp-x6eCV8F/view?usp=sharing",},


         
            
            
        ],
    },
    {
        id: 19,
        thumbnail:
            "",
        title: "M4 - Relative Clauses I",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {titulo: "📒[slides] Relative Clauses Explanation",url: "https://drive.google.com/file/d/1cxrD9paWOcm3w7pLDmE_WvAVi2FJQI1x/view?usp=sharing",},
            
            {titulo: "📒[slides] Defining Relative Clauses Exercise 1",url: "https://drive.google.com/file/d/1vLOQ-v7JohxwCcGIeIPZRB0VEIvE1P5b/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 1 key",url: "https://drive.google.com/file/d/1eUbQC4nby3BU4ob6iXnWLBgn1ucZtzGv/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 2",url: "https://drive.google.com/file/d/1zuEnn8IqoyVEFDGtioyJoAaF9beihzmL/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 2 key",url: "https://drive.google.com/file/d/1nAfUnBlJZYD6NAyXyrwcXyEGfEkGNMap/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 3",url: "https://drive.google.com/file/d/1JHS5Kog6HeXhj5GMgKY6GoafIv69Leoj/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 3 key",url: "https://drive.google.com/file/d/1g6Bcda-4oWQ_1ugTLgn-X2l4lAvRbmF2/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 4",url: "https://drive.google.com/file/d/1_yyKTGRy0f-fcCZ5BlRsMZXsBb2usP3g/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 4 key",url: "https://drive.google.com/file/d/1ug8Ybq084KuS4AMXVRJ76pN1rbYs93cA/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 1 ",url: "https://drive.google.com/file/d/1cFrsL8KTttdqE4BpsR2YGCU2BG_SrfSf/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 2 ",url: "https://drive.google.com/file/d/1HnZWwulcMoWRBuPlkGff-2xxJ9rX0x56/view?usp=sharing",},

            {titulo: "[Grammar Worksheet] WHOSE",url: "https://drive.google.com/file/d/10p5K6lvpYpdtEIhJNy-redgQ7aLBnVb2/view?usp=sharing",},

            {titulo: "[Grammar Quizz] Relative Clauses",url: "https://drive.google.com/file/d/1DqU2kvUjrAuTRfIzDQkpmleUANeWxnjP/view?usp=sharing",},
            {titulo: "[Grammar Quizz] WHO vs WHOSE",url: "https://drive.google.com/file/d/1Ab3XGgBtb8XhgPRFY-9K91ddlu_cEtpG/view?usp=sharing",},
            {titulo: "RC001 - Relative Clauses",url: "https://drive.google.com/file/d/1K8WkdJTAuJvGBwZcksUylm4xKDiC_efC/view?usp=sharing",},
            {titulo: "RC002 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1OFQyjqF7p2ppuJmqu76GnH3RlL4lkKzM/view?usp=sharing",},
            {titulo: "RC003 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1u24eoljpLI0AB8ROkDi-HSTenUlAubrj/view?usp=sharing",},
            {titulo: "RC004 - Relative Pronouns",url: "https://drive.google.com/file/d/19zQQNKYKQ3j81ooeAS7CLiG8klHE_2Qn/view?usp=sharing",},
            {titulo: "RC005 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1JwHY1cfaESrUMr9Dby2Gt21sxHRtZ5t6/view?usp=sharing",},
           

         
            
            
        ],
    },
   
    
   
    
    {
        id: 15,
        thumbnail:
            "https://i.ibb.co/T2gwBmd/level4.png",
        title: "Writing like Shakespeare",
        subtitle: "B2/C1",

        dateAdded: "B2",
        channel: "sdasd",
        description: "Aprende técnicas literarias avanzadas para enriquecer tu escritura y expresión creativa en inglés",
        enlaces: [
            {
                titulo: "📃[pdf] Essay  B2 Model",
                url: "https://drive.google.com/file/d/1shuKn4-Sgu3VW2SqO1Gbv4a3BNUjFWB0/view?usp=sharing",
            }, {
                titulo: "📃[pdf] Essay  B2 Model 2",
                url: "https://drive.google.com/file/d/1A3zKsg5My6XQlKxWRNiCoM_Jh5Wwepvp/view?usp=sharing",
            }
            ,
            {
                titulo: "📃[pdf] C1 Template Essay 2025",
                url: "https://drive.google.com/file/d/1ELdPTtS6V33-pBtJr2uRSizlrfuCH4nB/view?usp=sharing",
            },
            {
                titulo: "📃[pdf]Useful Language",
                url: "https://drive.google.com/file/d/1gMBSe_vvMgQq-IkIQtpDydmpuKq_YiMa/view?usp=sharing",
            },
            {
                titulo: "📃[pdf] Amazing Template Essay 2025",
                url: "https://drive.google.com/file/d/1GTnhTS-RWFKpJ2Q9DRhBOxb-IqgjIjmZ/view?usp=sharing",
            }
            ,
            {
                titulo: "📃[pdf] Writing Templates",
                url: "https://docs.google.com/document/d/1ynAsrV2Uj-uR0qrCDzGvDw8I2sXYlzEg/edit?rtpof=true&sd=true",
            },
            {
                titulo: "📃[pdf] How to write an Essay",
                url: "https://docs.google.com/presentation/d/1ulmNP0wMeqUi-ZlMpg6ngsCi_jjX9nBn/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            },{
                titulo: "📃[ppt] Advanced Transitions",
                url: "https://docs.google.com/presentation/d/1fGnuhWtExMKny18ZqasLeugnXi9cb9pU/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            },{
                titulo: "📃[Inf] Writing Mistakes everyone makes",
                url: "https://drive.google.com/file/d/17vYjDTq69ecevpRtiD1mSOevKqFLrOSM/view?usp=sharing",
            },
            
        ],
    },
    {
        id: 16,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Building Vocabulary",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Amplía tu vocabulario de manera efectiva y práctica con este curso diseñado para ayudarte a aprender y recordar nuevas palabras de forma rápida y duradera.",
        enlaces: [
            {  titulo:"📑 [Flash Cards] Fce Essential Words ",url: "https://quizlet.com/109647789/fce-vocabulary-flash-cards/?i=2oqoxh&x=1jqt"},
            {  titulo:"📑 [Game] Fce B2 First Prepositions ",url: "https://wordwall.net/play/39433/169/368"},

            {  titulo:"📑 [Anki Words] Necessary Words for Cambridge Exams ",url: "https://drive.google.com/file/d/1Nyh8Zhw0XGYZg-vFrNqpUT4oqNC0LozD/view"},
            {  titulo:"📑 [PDF] List of 200 Phrasal Verbs | B2 First (FCE) ",url: "https://docs.google.com/document/d/1kUtVFcyPfupiE32q77xJwfQ1afTjWB6nm39tZsNDoxI/edit"},
            {  titulo:"📑 [PDF] Collocation 01 | B2 First (FCE|CAE) ",url: "https://drive.google.com/file/d/1dFsaNG_Ln6tt29-fHuf-L22ktIRxnBjf/view?usp=sharing"},
            {  titulo:"📑 [App] Dictionary ",url: "https://www.mediafire.com/file/zofkpkpcylqtpfp/MacMillanED_2nd_Edition.rar/file"},
            {  titulo:"📑 [PDF] Answer Sheet ",url: "https://drive.google.com/file/d/16srt09bwR_CaPRNKel7WfErJSVqTyXl4/view?usp=sharing"},

            {  titulo:"📑 [PDF] Prepositions After Verbs & Adjectives ",url: "https://docs.google.com/document/d/1CeVFrtcUUUYYfBOyHIvXkZ0mUjl3vx7ri-L0BYkARd8/edit#heading=h.te6z9i49xc6a"},

        ],
    },
    {
        id: 17,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Inglés con Anime",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Amplía tu vocabulario de manera efectiva y práctica con este curso diseñado para ayudarte a aprender y recordar nuevas palabras de forma rápida y duradera.",
        enlaces: [
            {  titulo:"🎥[Video] Aprende inglés con Dragon Ball Z - Conversaciones ",url: "https://drive.google.com/file/d/1wBA_z3emPwA8_7zG4PTh_3eM9kIrsw_G/view?usp=sharing"},
            {  titulo:"🎥[Video]  Picoro entrena a Gohan ",url: "https://drive.google.com/file/d/1cSJBlQ_0_N-hLgm4A-g-wNnv9U9x1lJZ/view?usp=sharing"},
            {  titulo:"🎥 [Video] Ingles con Naruto ",url: "https://drive.google.com/file/d/1olidUMObF_HhIZ0BMJGQrRpZERjm-euc/view?usp=sharing"},
            {  titulo:"🎥 [Video] El sacrificio de Vegeta ",url: "https://youtu.be/ce1JkqjXKJ4"},
            {  titulo:"🎥 [Video] Useful Expressions Death Note ",url: "https://youtu.be/MTaLzZikzv4"},
            {  titulo:"🎥 [Video] Useful Expressions One Punch Man ",url: "https://youtu.be/n_DcqiFayc4"},
            {  titulo:"🎥 [Video] La fusion de Vegito ",url: "https://youtu.be/ma7q6esT3cg"},
            {  titulo:"🎥 [Video] Useful Expression My hero Academy ",url: "https://youtu.be/8sPqgQlfKsQ"},
            {  titulo:"🎥 [Video] Useful Expression Goku enseña la tecnica de la Fusion ",url: "https://youtu.be/S5yooa_kHDY"},


        ],
    }, {
        id: 18,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Exámenes Center",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            {  titulo:"📝 Examen 01  ",url: "https://drive.google.com/file/d/1Sk4W7Ax3Ao9ZqGR4sVY4IFik3Jq6BQ_N/view?usp=sharing"},

            {  titulo:"📝[Test 01 ] FCE + SOLUCIONARIO ",url: "https://docs.google.com/document/d/17v-Bh_q-bTXR6ZzgRYy-GD6ZMx6EiIdT/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true"},
            {  titulo:"📝[Test 02 ] FCE + SOLUCIONARIO ",url: "https://docs.google.com/presentation/d/1LijSovlmiSEB4cvyYhr0PcGe3ZDpmDSI/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true"},

            {  titulo:"📝[Test] Key Word Transformation 01 ",url: "https://drive.google.com/file/d/1Ng-AL8s5uNqA4AeVSa9x-4ySFH_dqsKU/view?usp=sharing"},
            {  titulo:"📝🔑[Test Answer Key] Key Word Transformation 01 ",url: "https://docs.google.com/presentation/d/1_lR0KYShBJeyFw-ZOuMIEwwLyIdLb2s591vIc4pAIsU/edit?usp=sharing"},

            {  titulo:"📝[Test] Multiple Choice Cloze 01 ",url: "https://drive.google.com/file/d/1Y-2SMBjU5xafwMwdH2VB8NJMWwKQMB5-/view?usp=sharing"},
            {  titulo:"📝🔑[Test Answer Key] Multiple Choice Cloze 01",url: "https://docs.google.com/presentation/d/1koBZiWPQtnw6GgFEfWpNORHWd0TvwYYnRbr661Ahh94/edit?usp=sharing"},

            {  titulo:"📝[Test] Open Cloze 01 ",url: "https://drive.google.com/file/d/1yRCvF2OW3VJfHSqREMmUb4RzAXK6Hfg1/view?usp=sharing"},
            {  titulo:"📝[Test] Word Formation 01 ",url: "https://drive.google.com/file/d/1SOnsELpD7Y4laW2l--YpXeKcut6QM8ZA/view?usp=sharing"},
            {  titulo:"🗣[Test] Speaking Section 01 ",url: "https://drive.google.com/file/d/1tG0g65N35lS8hp1r4LRPDSkynxug5C51/view?usp=sharing"},


        ],
    },{
        id: 21,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "If-Clauses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ IF001 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1zkFdLJpLESep41DLgUElfhiyuBzCU_fi/view?usp=sharing", },
            { titulo: "✍ IF002 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1eQ-z-lbU8tKm_BZgrrgJwfkvl2Erbf2c/view?usp=sharing", },
            { titulo: "✍ IF003 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/182p9f-HK7c0eGODpwB3VstwcwQKgmtH7/view?usp=sharing", },
            { titulo: "✍ IF004 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/19z4Pi3T60d7n505lFrt22npAN8bMZG4d/view?usp=sharing", },
            { titulo: "✍ IF005 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/12FhAI14xsU_5O_Bau-AQFPIQPMwQrIPT/view?usp=sharing", },
            { titulo: "✍ IF006 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/1FiXA09T66glsOEsLQ6zJv86uzRS5NBAC/view?usp=sharing", },
            { titulo: "✍ IF008 - IF-Clauses - Conditional 1 ",url: "https://drive.google.com/file/d/1frj2F8CUX2wo_ASftPHyFFK037reIw9E/view?usp=sharing", },
            { titulo: "✍ IF009 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1dk_3njjacg-x5I-707uoA6ieWhAB8TyU/view?usp=sharing", },
            { titulo: "✍ F010 - IF Clauses - Type 1 ",url: "https://drive.google.com/file/d/1cW9NMcLR6qwyc9TgGIgwcJl41iH9tWMA/view?usp=sharing", },
            { titulo: "✍ IF011 - IF Clauses - Type 2 ",url: "https://drive.google.com/file/d/1H_R3hcWhSwJCTfL____KykDG1pfuyoK5/view?usp=sharing", },
            { titulo: "✍ IF012 - IF Clauses - Type 3 ",url: "https://drive.google.com/file/d/1cG8XOFirGzvJJx7b_Xvv1c1uR38CuBlH/view?usp=sharing", },

            


        ],
    }
    , {
        id: 23,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Present Perfect Tense",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1D0VK7vPjtlAMOc8WqxQUQn62_F3-uJsa/view?usp=sharing", },            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1jgcxBuSKBZ6LdIQbWXL3_4lJDv4D8QVa/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1jvFbc4GPFUHXIgx0gmbgslQQz7KmIMG0/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1iCSWPTOFu1vGbkEaW6xSPh-Z_-koKr3V/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1uik-f0MFXujPMnbgmOiCIegxSmWAI5qI/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1CyruZuJFKhWpzmNmFQ9H9oigRjqgY0ui/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1i-A68Tl92LNR87MyIWPPTEceTrIlU_hw/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/11Jj4BydUErvqumFiFy5goX5pGQkZq9HY/view?usp=sharing", },

            
        ],
    }, {
        id: 26,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Future Tenses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Ways of Expressing Future Tense ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },    
            { titulo: "✍  Future Tenses ",url: "https://drive.google.com/file/d/1uQEVuavBgrytYsOTlD3dAg8qZDCtZEa_/view?usp=sharing", },
            
           

            
        ],
    },
    {
        id: 26,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "TOEFL - Grammar",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Modal Verbs ",url: "https://drive.google.com/file/d/1Nblkea4-3PmGpg_cOHpi9NXn_HRNGj_V/view?usp=sharing", },    
            
            { titulo: "✍ Comparatives & Modifiers  ",url: "https://drive.google.com/file/d/1Nblkea4-3PmGpg_cOHpi9NXn_HRNGj_V/view?usp=sharing", },    
            { titulo: "✍ Comparatives & Modifiers II  ",url: "https://drive.google.com/file/d/1XFgGX1sdYUdhvYpKfK4e_Cqj_mQOie3-/view?usp=sharing", },    
            { titulo: "✍ Comparatives & Modifiers III  ",url: "https://drive.google.com/file/d/1RdfYJnYLdMF7j3sS-hKJesOMGmqmdXP3/view?usp=sharing", },    
            { titulo: "✍ Connectors  ",url: "https://drive.google.com/file/d/1RdfYJnYLdMF7j3sS-hKJesOMGmqmdXP3/view?usp=sharing", },    
            { titulo: "✍ Correct Sentence Multiple Choice  ",url: "https://drive.google.com/file/d/1fDfIVqWLrLhqVHo-U1WMzsYqzgQ8M1Tr/view?usp=sharing", },    

            { titulo: "✍ Parallel Structures ",url: "https://drive.google.com/file/d/1pTDJGKjUyVQSG6tEne2HdTIcdu96LDuE/view?usp=sharing", },    

            { titulo: "✍Word Choice 1  ",url: "https://drive.google.com/file/d/1QBCWjTJ69eYmnp5LjxD32_sHESeUf2PT/view?usp=sharing", },    
            { titulo: "✍Word Choice 2  ",url: "https://drive.google.com/file/d/11AcnwZ85R7GsoaU0kGKzYwV7wAzadRQ0/view?usp=sharing", },    
            { titulo: "✍Word Choice 3  ",url: "https://drive.google.com/file/d/1mYW1BkrSOc_JDU0e-bH2w6-S5MwBg6LV/view?usp=sharing", },    
            { titulo: "✍Word Choice 4  ",url: "https://drive.google.com/file/d/15BawZ93O21V7AC3mR_4sW29hzftMdMNd/view?usp=sharing", },    
            { titulo: "✍Noun Phrases ",url: "https://drive.google.com/file/d/16oHUr1WoZ8h3OuKA3J_i7h_4-yrDMWpy/view?usp=sharing", },    
            { titulo: "✍Noun Phrases 2 ",url: "https://drive.google.com/file/d/1YHlLWaR-D7oOGE7nsit_ciUJOyhGg__u/view?usp=sharing", },    
            { titulo: "✍Verbs & Tenses ",url: "https://drive.google.com/file/d/1maGomb9hSFctNQciK0iQ65MS6NcBmyB9/view?usp=sharing", },    
            { titulo: "✍Verbs & Tenses 2 ",url: "https://drive.google.com/file/d/1hmNX83_c71spUojY26NX0Lr1xu8lFatr/view?usp=sharing", },    
            { titulo: "✍Negative Word Choice  ",url: "https://drive.google.com/file/d/1EIhDVNF1zmA3aHY5GWLMlY8yFfU0YvsJ/view?usp=sharing", },    
            
            { titulo: "✍ Pronouns Multiple Choice  ",url: "https://drive.google.com/file/d/1NW1tqZPEhz_x-C3R_JkIxlPI2AEpo2Ip/view?usp=sharing", },    
            { titulo: "✍Prepositions 1 ",url: "https://drive.google.com/file/d/1zBC_Z2Yx-v6snlVv04J7f3phtsltg9ZJ/view?usp=sharing", },    
            { titulo: "✍Prepositions 2 ",url: "https://drive.google.com/file/d/1RmqHsasdx0v9YIwCH5-kQkgYl8N-PtFB/view?usp=sharing", },    
            { titulo: "✍Much or Many Exercise  ",url: "https://drive.google.com/file/d/1RCGY76NB6Sw920zvaJ5XDSdHxFv3VrCh/view?usp=sharing", },    
            { titulo: "✍ Some or Many Exercise  ",url: "https://drive.google.com/file/d/1FnvjpGc0aO_CYRW4X029MTHsiXeSc4nu/view?usp=sharing", },    
            { titulo: "✍ Last or Latter Exercise  ",url: "https://drive.google.com/file/d/1cg_ddekwaAS49iRAbDxV0CiJlM3Y9o0R/view?usp=sharing", },    
            { titulo: "✍ Superlatives  Exercise  ",url: "https://drive.google.com/file/d/1MfGGvdY2UGYMWWYg4y6pMWx6x9ijW85J/view?usp=sharing", },    
            { titulo: "✍ Past Tense  Exercise  ",url: "https://drive.google.com/file/d/1xqAs1XF73eyqoH7hnyCpg_9QobkecHca/view?usp=sharing", },    
            { titulo: "✍ Conditional Matching Exercise ",url: "https://drive.google.com/file/d/1pceZifEmXB5sk-AmhG4GqP00Tj63rFVA/view?usp=sharing", },    

            { titulo: "✍ Gerund or Infinitive Exercise  ",url: "https://drive.google.com/file/d/1FAsG76_HqxXJIftk59cJIuM-wbXupH93/view?usp=sharing", },    

        ],
    }
];
